// services/themeService.js
import { updateColors } from '../ColorConfig/colorconfig';

export const fetchTheme = async () => {
  try {
    const response = await fetch('https://api.dremerz.net/api/DZ_8923_Idlbay_ThemeChanger_ThemeChangerList');
    
    if (response.ok) {
      const data = await response.json();
      if (data && data.length > 0) {
        const theme = data[0];
        updateColors(theme);
        return theme;
      }
    }
    
    console.warn('Using default theme due to API error');
    return null;
  } catch (error) {
    console.error('Error fetching theme:', error);
    return null;
  }
};